import { DefaultState } from 'store/types';

export const GET_LODGINGS_COUNT_DATA_REQUEST = 'GET_LODGING_COUNT_DATA_REQUEST';
export const GET_LODGINGS_COUNT_DATA_SUCCESS = 'GET_LODGING_COUNT_DATA_SUCCESS';
export const GET_LODGINGS_COUNT_DATA_FAILURE = 'GET_LODGING_COUNT_DATA_FAILURE';

export interface GetLodgingsCountData {
  active: number;
  closed: number;
}

export type GetLodgingsCountState = DefaultState & {
  contents?: GetLodgingsCountData;
};

interface ReadGetLodgingsCountDataRequest {
  type: typeof GET_LODGINGS_COUNT_DATA_REQUEST;
};

interface ReadGetLodgingsCountDataSuccess {
  type: typeof GET_LODGINGS_COUNT_DATA_SUCCESS,
  contents: GetLodgingsCountData;
}

interface ReadGetLodgingsCountDataFailure {
  type: typeof GET_LODGINGS_COUNT_DATA_FAILURE;
}

export type GetLodgingsCountActionTypes = ReadGetLodgingsCountDataRequest | ReadGetLodgingsCountDataSuccess | ReadGetLodgingsCountDataFailure;